var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10a.5.5 0 0 1-.5-.5v-.67c0-.635.401-1.204 1-1.415a1.503 1.503 0 0 0 .56-2.475A1.488 1.488 0 0 0 8 4.501c-.4 0-.777.156-1.06.44-.284.282-.44.659-.44 1.06a.5.5 0 0 1-1 0c0-.669.26-1.296.733-1.768A2.484 2.484 0 0 1 8 3.501c1.379 0 2.5 1.122 2.5 2.5 0 1.057-.67 2.004-1.667 2.357a.5.5 0 0 0-.333.471V9.5a.5.5 0 0 1-.5.5zm0 2.5A.75.75 0 1 0 8 11a.75.75 0 0 0 0 1.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zM8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.8f2e0a3fd696893996ca5121f1a45dff.svg";
export { ForwardRef as ReactComponent };